import { MwlIcons } from "../components/MwlIcons";

export const ExifComponent = ({ icon, name, value }) => (
  <div className="exif">
    <MwlIcons icon={icon} />
    <span> &nbsp;{value}</span>
  </div>
);
